import React, { useState } from 'react';
import OrangeButton from '../buttons/orange-button';
import OrangeButtonOutline from '../buttons/orange-button-outline';
import { useNavigate } from 'react-router-dom';

const NexusSection = () => {
  const navigate = useNavigate();
  const [showSignupModal, setShowSignupModal] = useState(false);
  const features = [
    'Expert Vetted Tutors',
    'In-person & online options',
    'AI-powered study support',
    'Progress tracking tools',
  ];
  return (
    <div className="mx-auto mt-[48px] flex flex-col items-center gap-4 md:!mt-[80px] md:gap-12 lg:flex-row">
      <div className="w-full pr-4 lg:w-1/2 lg:p-0">
        <img src="/images/home/Nexus-InApp-Image.png" alt="" />
      </div>
      <div className="container w-full !max-w-[502px] space-y-4 !px-6 md:!pr-0 ">
        <div className="space-y-4">
          <h2 className="fredokaOne text-[32px]  font-normal leading-tight tracking-[-0.64px] text-[#012E33] md:text-[40px] md:tracking-[-0.8px]">
            AI-Powered Session Summaries & Recordings 
          </h2>

          <p className="fredoka text-[18px] font-normal leading-[32px] tracking-[-0.18px] text-[#678285] md:text-[22px] md:tracking-[-0.22px]">
            Download our powerful Nexus application to automatically record, transcribe, and 
            summarize every tutoring session to streamline follow-ups and progress tracking.
          </p>
        </div>

        {/* <div className="space-y-4   md:pt-2">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center gap-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#66CDCC] p-1">
                <img className="h-6 w-6" src="/images/icons/yellow-check.svg" alt="" />
              </div>
              <span className="fredoka text-[22px] font-medium leading-8 tracking-[-0.22px] text-[#012E33]">
                {feature}
              </span>
            </div>
          ))}
        </div> */}

        <div className="flex flex-col gap-4 pt-4 lg:flex-row">
          <OrangeButton
            className="fredokaOne !rounded-2xl"
            onClick={() => setShowSignupModal(true)}
            label={'Try Nexus Now'}
          />
          <OrangeButtonOutline
            onClick={() => navigate('/products/academic-tutoring')}
            label={'Learn More'}
          />
        </div>
      </div>
    </div>
  );
};

export default NexusSection;
